export const COLOR_PRESETS: readonly { value: string; name: string }[] = [
  { value: '#e5484d', name: 'composer.colorRed' },
  { value: '#f76b15', name: 'composer.colorOrange' },
  { value: '#ffc53d', name: 'composer.colorYellow' },
  { value: '#46a758', name: 'composer.colorGreen' },
  { value: '#12a594', name: 'composer.colorTeal' },
  { value: '#0090ff', name: 'composer.colorBlue' },
  { value: '#6e56cf', name: 'composer.colorViolet' },
  { value: '#d6409f', name: 'composer.colorPink' },
  { value: '#ad7f58', name: 'composer.colorBrown' },
  { value: '#8b8d98', name: 'composer.colorGrey' },
  { value: '#ffffff', name: 'composer.colorWhite' },
  { value: '#000000', name: 'composer.colorBlack' },
];
